<template>
  <div id="product">
    <header>
      <img src="../../assets/img/product5.png" alt="">
      <section class="tag">
        <img src="../../assets/img/product6.png" alt="">
      </section>
    </header>
    <main>
      <section class="block-inverse container">
        <img src="../../assets/img/product2.jpg" alt="">
        <section>
          <h3>阿启泰文化艺术APP</h3>
          <p>平台以专业视角、多元维度、优质内容为核心，构建了专业的文化艺术大数据体系。平台汇聚经典书籍、学术文献等资源，覆盖历史、文学、科技、艺术等多元领域；同时集成谚语数据库、汉蒙翻译库、有声书、音视频内容、非遗技艺教学、AI智能服务、AI智慧阅读等特色内容与功能，为各类用户提供精准、高效的知识服务。无论是学术研究文献、日常阅读名著，还是艺术创作素材、沉浸式文化体验，都可高效获取，真正实现“把图书馆装进手机，让文化艺术触手可及”。</p>
        </section>
      </section>
      <section class="title container">
        <img src="../../assets/img/product19.png" alt="">
        <h1>阿启泰·文化艺术<span>大数据</span></h1>
      </section>
      <ul class="container number" style="width: 1400px!important;">
        <li>
          <p>蒙文图书数字资源</p>
          <h3>3万+</h3>
        </li>
        <li>
          <p>数字期刊报刊资源</p>
          <h3>2万+</h3>
        </li>
        <li>
          <p>蒙文语料库资源</p>
          <h3>2万+</h3>
        </li>
        <li>
          <p>目录资源</p>
          <h3>200万+</h3>
        </li>
        <li>
          <p>多语言电子词汇资源</p>
          <h3>100万+</h3>
        </li>
        <li>
          <p>精品音视频资源</p>
          <h3>2000+</h3>
        </li>
      </ul>
      <section class="title container">
        <img src="../../assets/img/product19.png" alt="">
        <h1>阿启泰·书籍文献管理系统<span>方案</span></h1>
      </section>
      <section class="block-shun container">
        <section>
          <h5>阿启泰书籍文献管理系统 · 解决方案</h5>
          <h3>集群式书籍文献管理系统</h3>
          <p>
            集群式书籍文献管理系统通过书籍文献管理平台,实现RFID书籍管理系统、24小时自助书籍文献管理系统以及智能微型书籍文献管理系统，与各级书籍文献主管单位连接，实现管理端对辖区内所有书籍文献的单平台统一管理，建设书籍文献馆联合服务体系。</p>
        </section>
        <img src="../../assets/img/product3.jpg" alt="">
      </section>
      <section class="block-inverse container">
        <img src="../../assets/img/product16.jpg" alt="">
        <section>
          <h5>阿启泰书籍文献管理系统 · 解决方案</h5>
          <h3>分布式书籍文献管理系统</h3>
          <p>分布式书籍文献管理系统将实现读者借书、还书、续借、预借、查询等基本服务功能。帮助管理员更方便轻松的管理书籍文献，以点带面让书香覆盖在城市每个角落。打通全民阅读“最后一公里”。</p>
        </section>
      </section>
      <section class="block-shun container">
        <section>
          <h5>阿启泰书籍文献管理系统 · 总体架构设计</h5>
          <h3>阿启泰书籍文献管理平台</h3>
          <p>阿启泰书籍文献管理平台有软件和硬件组成。</p>
        </section>
        <img src="../../assets/img/product7.jpg" alt="">
      </section>
      <section class="block-inverse container">
        <img src="../../assets/img/product8.jpg" alt="">
        <section>
          <h5>阿启泰书籍文献管理系统 · 部分硬件</h5>
          <h3>智能微型图书馆</h3>
          <p>智能微型图书馆是一种移动图书文献流动设备。它让书籍文献真正走进某一房间和楼层，解决了传统图书馆室内场地小、位置远、服务时间短的局限。
            它是传统图书馆的有益补充，具有借书、还书续借、预借、查询等基本服务功能,就是个小型的“移动图书馆”。</p>
        </section>
      </section>
      <section class="block-shun container">
        <section>
          <h5>阿启泰书籍文献管理系统 · 部分硬件</h5>
          <h3>图书馆安全门</h3>
          <p>
            图书馆安全门是专为阿启泰图书馆设计的高性能防盗设备，此系列安全门采用RFID技术和三维全向感应设计，支持图书电子标签任意方向的检测;支持多种报警检测模式;除防盗功能外,亦支持对进出读者人次的双向统计，方便馆方随时了解图书馆进出馆的人流数量;同一系统可支持多片安全门并排安装使用。</p>
        </section>
        <img src="../../assets/img/product9.jpg" alt="">
      </section>
      <section class="block-inverse container">
        <img src="../../assets/img/product10.jpg" alt="">
        <section>
          <h5>阿启泰书籍文献管理系统 · 部分硬件</h5>
          <h3>读者证</h3>
          <p>·每张读者证具有唯一序列号
            <br>
            ·用于图书借还、检索、承载个人信息及借阅记录
            <br>
            ·读者证具有较高的安全性，防止存储在读者证中的
            信息被泄露
            <br>
            ·读者证每一面印制的内容可根据图书馆要求定制</p>
        </section>
      </section>
      <section class="block-shun container">
        <section>
          <h5>阿启泰书籍文献管理系统 · 部分硬件</h5>
          <h3>升降式移动还书箱</h3>
          <p>
            ·根据负载自动升降结构，运行稳定可靠
            <br>
            ·以电泳铝材为骨架，四周封板为铝塑纤维板
            <br>
            ·脚轮采用超静音耐磨脚轮，运行时超低噪音
            <br>
            ·平台升降高度:≤450mm
            <br>
            ·装书容量:150L (可放80-200册)
          </p>
        </section>
        <img src="../../assets/img/product11.jpg" alt="">
      </section>
      <section class="block-inverse container">
        <img src="../../assets/img/product12.jpg" alt="">
        <section>
          <h5>阿启泰书籍文献管理系统 · 部分硬件</h5>
          <h3>自助借还书机</h3>
          <p>自助借还书机通过对粘贴有RFID标签的资料、书籍进行扫描、识别，将人工借还改为自助借还，提高了借阅服务质量。</p>
        </section>
      </section>
      <section class="block-shun container">
        <section>
          <h5>阿启泰书籍文献管理系统 · 部分硬件</h5>
          <h3>RFID标签</h3>
          <p>
            ·RFID标签自带存储空间
            <br>
            ·具有很好的防冲突性能
            <br>
            ·具有多标签识别功能
            <br>
            ·非接触式地读取和写入
          </p>
        </section>
        <img src="../../assets/img/product13.jpg" alt="">
      </section>
      <section class="block-inverse container">
        <img src="../../assets/img/product14.jpg" alt="">
        <section>
          <h5>阿启泰书籍文献管理系统 · 部分硬件</h5>
          <h3>分体式馆员工作站</h3>
          <p>馆员工作站是集成RFID读写装置、各种类型读者证识别装置、条形码识别装置于一体的设备,对RFID图书/档案标签进行编写、识别和流通状态处理,应用于标签转换以及图书人工借还环节。</p>
        </section>
      </section>
      <section class="block-shun container">
        <section>
          <h5>阿启泰书籍文献管理系统 · pc端软件模块</h5>
          <h3>蒙汉双语pc端管理系统</h3>
          <p>
            本系统采用B/S架构的重直管理模式，集图书流通管理设备管理、OPAC管理于一体，不仅实现了区域管理端对客户端的在线管理，而且实现了资源共享和建设图书馆联合服务体系。
          </p>
        </section>
        <img src="../../assets/img/product15.jpg" alt="">
      </section>

      <section class="title container">
        <img src="../../assets/img/product19.png" alt="">
        <h1>阿启泰·书籍文献管理系统<span>创新实践</span></h1>
      </section>
      <section class="footer container">
        <section>
          <img src="../../assets/img/product18.png" alt="">
          <button>查看更多</button>
        </section>
        <section>
          <img src="../../assets/img/product17.png" alt="">
          <button>查看更多</button>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Product'
}
</script>

<style lang="less" scoped>
.container {
  width: 1040px;
  margin: 0 auto;
}

#product {
  padding-top: 70px;
  //background: url("");
  color: white;

  header {
    width: 100%;
    background: url("../../assets/img/product1.png") no-repeat center center;
    background-size: cover;
    height: 577px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > img {
      width: 708px;
    }

    .tag {
      width: 1000px;
      margin-top: 104px;
      text-align: right;

      img {
        height: 28px;
        cursor: pointer;
      }
    }
  }

  main {
    width: 100%;
    background: white;
    color: black;
    overflow: hidden;

    .title {
      height: 67px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 67px;

      img {
        width: 116px;
        height: 40px;
      }

      h1 {
        line-height: 67px;
        font-size: 48px;
        margin-left: 35px;

        span {
          color: #1F3363;
          margin-left: 34px;
        }
      }
    }

    .number {
      display: flex;
      height: 250px;
      margin-top: 39px;
      justify-content: center;
      margin-bottom: 142px;

      li {
        width: 250px;
        height: 250px;
        background: linear-gradient(180deg, #FEFEFE 0%, #E3E3E3 100%);
        box-shadow: 0 5px 8px 0 #C8C8C8;
        border-radius: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p {
          color: #333333;
          font-size: 21px;
          font-weight: bold;
        }

        h3 {
          margin-top: 18px;
          margin-bottom: 9px;
          color: #055AD9;
          font-size: 28px;
          line-height: 63px;
        }
      }

      li:nth-child(1) {
        margin-left: 0;
      }

      li:nth-child(2) {
        margin-left: -30px;
      }

      li:nth-child(3) {
        margin-left: -30px;
      }

      li:nth-child(4) {
        margin-left: -30px;
      }
      li:nth-child(5) {
        margin-left: -30px;
      }
      li:nth-child(6) {
        margin-left: -30px;
      }
    }

    .block-shun {
      height: 340px;
      border-bottom: 2px #E3E7E8 solid;
      margin-bottom: 60px;
      margin-top: 105px;
      display: grid;
      grid-template-columns: repeat(2, 520px);
      justify-items: flex-start;

      img {
        height: 338px;
        justify-self: center;
      }

      section {
        align-self: flex-start;
        justify-self: flex-start;

        h5 {
          color: #333333;
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 26px;
        }

        h3 {
          color: #333333;
          font-size: 30px;
          line-height: 42px;
        }

        p {
          width: 441px;
          color: #888888;
          margin-top: 42px;
          font-size: 14px;
          line-height: 28px;
          font-weight: 400;
        }
      }
    }

    .block-inverse {
      height: 340px;
      border-bottom: 2px #E3E7E8 solid;
      margin-bottom: 60px;
      margin-top: 105px;
      display: grid;
      grid-template-columns: repeat(2, 520px);
      justify-items: flex-start;

      img {
        height: 338px;
        justify-self: center;
      }

      section {
        align-self: flex-start;
        justify-self: flex-start;
        padding-left: 79px;

        h5 {
          color: #333333;
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 26px;
        }

        h3 {
          color: #333333;
          font-size: 30px;
          line-height: 42px;
        }

        p {
          width: 441px;
          color: #888888;
          margin-top: 42px;
          font-size: 14px;
          line-height: 28px;
          font-weight: 400;
        }
      }
    }

    .footer {
      margin: 44px auto;
      display: flex;
      justify-content: space-between;
      height: 408px;

      section {
        width: 502px;
        height: 408px;
        background: #1D3662;
        border-radius: 5px;
        flex-shrink: 0;
        position: relative;
        img{
          width: 100%;
        }
        button{
          position: absolute;
          padding: 8px 60px;
          background: #FFFFFF;
          color: #1B1E58;
          border: none;
          border-radius: 5px;
          outline: none;
          bottom: 30px;
          left: 50%;
          font-weight: 600;
          font-size: 18px;
          transform: translateX(-50%);
          cursor: pointer;
          transition: 0.5s linear;
        }
        button:hover{
          background: #6A98F1;
          color: white;
        }
      }
    }
  }
}
</style>
